var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#F2FFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.66 12.644h-9.093c-1.085 0-1.965.88-1.965 1.964v18.784c0 1.085.88 1.964 1.965 1.964h13.866c1.086 0 1.965-.88 1.965-1.965v-14.03l-6.738-6.717z",
    stroke: "#35404A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#31B59F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.941 25.67v6.214M24.514 23.099v8.785M29.087 19.671v12.213"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.f459a278e56ae82318ce255d8bea60e2.svg";
export { ForwardRef as ReactComponent };